module.exports = __webpack_public_path__ + "images/embed/icons/double_down_arrow.gif";